import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import OnDemandReportCreation from '../page-content/content-publishing/on-demand-report-creation.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const MenuWrapperComponent = makeShortcode("MenuWrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading" variant="fullwidth" theme="dark" customLayout className="herobgImage Hero-Banner" mdxType="Hero" />
    <h1 {...{
      "id": "acrobat-services-api-use-cases"
    }}>{`Acrobat Services API Use Cases`}</h1>
    <MenuWrapperComponent menuItem='subMenuPages' slots="content" repeat="1" theme="lightest" className="On-Demand-Report-Creation" mdxType="MenuWrapperComponent" />
    <OnDemandReportCreation mdxType="OnDemandReportCreation" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      